import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { FAQS } from "@/data/site";

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section data-testid="faq-section" className="bg-white py-24 md:py-32">
      <div className="mx-auto max-w-3xl px-6 md:px-12">
        <SectionHeading
          align="center"
          overline="FAQ"
          title="Common Questions"
        />
        <div className="mt-14 space-y-3">
          {FAQS.map((faq, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={faq.q} delay={i * 0.04}>
                <div
                  data-testid={`faq-item-${i}`}
                  className={`overflow-hidden rounded-2xl border transition-[border-color,background-color] duration-300 ${
                    isOpen ? "border-electric/30 bg-slate-50" : "border-slate-200 bg-white"
                  }`}
                >
                  <button
                    data-testid={`faq-question-${i}`}
                    aria-expanded={isOpen}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                  >
                    <span className="font-display text-base font-medium text-slate-900">
                      {faq.q}
                    </span>
                    <motion.span
                      animate={{ rotate: isOpen ? 45 : 0 }}
                      transition={{ duration: 0.3 }}
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${
                        isOpen ? "bg-electric text-white" : "bg-slate-100 text-slate-500"
                      }`}
                    >
                      <Plus className="h-4 w-4" />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      >
                        <p
                          data-testid={`faq-answer-${i}`}
                          className="px-6 pb-6 text-sm leading-relaxed text-slate-600"
                        >
                          {faq.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
